import { Component, Input } from '@angular/core';
import { HeaderSlim } from './models/header-slim.interfaces';

@Component({
  selector: 'idp-header-slim',
  templateUrl: './header-slim.component.html',
  styleUrls: ['./header-slim.component.scss']
})
export class HeaderSlimComponent {
  @Input() header: HeaderSlim = {
    logo: {
      mainLogo: '',
      mainLogoUrl: '',
      mainLogoAltText: '',
      mainLogoNewTab: '',
      subLogo: '',
      subLogoUrl: '',
      subLogoAltText: '',
      subLogoNewTab: '',
      busiLogo: '',
      busiLogoUrl: '',
      busiLogoAltText: '',
      busiLogoNewTab: '',
      slimheaderLogo: '',
      slimheaderLogoUrl: '',
      slimheaderLogoAltText: '',
      slimheaderLogoNewTab: ''
    },
    lightHeader: false
  };
}
